import numberFormat from "@/helpers/numberFormat";
import { Link } from "@inertiajs/inertia-react";
import { DateTime } from "luxon";
import React from "react";

import { getMonthNameByDate } from '@/helpers/date';

const Table = ({ totals, office, startDate, endDate }) => {
    const getTotalsByType = (type) => {
        return totals.types
            .filter(({ type: totalType }) => totalType === type)
            .reduce((acc, { total }) => acc + total, 0)
    }

    console.log('los totals', totals)

    return (
        <div className="relative overflow-x-auto w-full">
            <table className="w-full text-sm text-left text-gray-500">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                    <tr>
                        {[
                            "Fecha",
                            "Total MercadoPago (WEB)",
                            "Total Redelcom",
                            "Total Manual",
                            "Total Productos Redelcom",
                            "Total Productos Efectivo",
                            "Total s/iva",
                            "Impuesto",
                            "Total"
                        ].map((title, index) => (
                            <th
                                key={`thead-table-summary-${index}`}
                                scope="col"
                                className="px-6 py-3"
                            >
                                {title}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {totals.dates
                        .sort((a, b) => {
                            const dates = {
                                a: DateTime.fromFormat(
                                    a.date,
                                    "yyyy-MM-dd"
                                ).toMillis(),
                                b: DateTime.fromFormat(
                                    b.date,
                                    "yyyy-MM-dd"
                                ).toMillis(),
                            };

                            if (dates.a < dates.b) {
                                return -1;
                            }

                            if (dates.a > dates.b) {
                                return 1;
                            }

                            return 0;
                        })
                        .map(({ date, total, total_no_iva }, index) => (
                            <tr
                                key={`totals-dates-table-summary-item-${date}-${index}`}
                                className="bg-white border-b"
                            >
                                <th
                                    scope="row"
                                    className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap"
                                >
                                    <Link
                                        href={route("order.daily", {
                                            office: office.slug,
                                            date,
                                        })}
                                    >
                                        {DateTime.fromFormat(
                                            date,
                                            "yyyy-MM-dd"
                                        ).toLocaleString({
                                            timeZone: "America/Santiago",
                                            day: "2-digit",
                                        })}{" "}
                                        de{" "}
                                        {getMonthNameByDate(
                                            DateTime.fromFormat(
                                                date,
                                                "yyyy-MM-dd"
                                            ).toJSDate()
                                        ).toLowerCase()}{" "}
                                        {startDate.getFullYear() !==
                                            endDate.getFullYear() && (
                                            <>
                                                de{" "}
                                                {DateTime.fromFormat(
                                                    date,
                                                    "yyyy-MM-dd"
                                                )
                                                    .toJSDate()
                                                    .getFullYear()}
                                            </>
                                        )}
                                    </Link>
                                </th>
                                {["mercadopago", "redelcom", "manual", "product-redelcom", "product-manual"].map(
                                    (type, index) => {
                                        const total =
                                            totals.types.find(
                                                (totalType) =>
                                                    totalType.type === type &&
                                                    totalType.date === date
                                            )?.total || 0;      
                                        return (
                                            <td
                                                key={`tbody-td-table-prices-by-type-list-item-${type}-${index}`}
                                                className="px-6 py-4"
                                            >
                                                $
                                                {numberFormat(
                                                    total,
                                                    0,
                                                    "",
                                                    "."
                                                )}
                                            </td>
                                        );
                                    }
                                )}
                                <td className="px-6 py-4">
                                    ${numberFormat(total_no_iva, 0, "", ".")}
                                </td>
                                <td className="px-6 py-4">
                                    ${numberFormat(total - total_no_iva, 0, "", ".")}
                                </td>
                                <td className="px-6 py-4">
                                    ${numberFormat(total, 0, "", ".")}
                                </td>
                            </tr>
                        ))}
                </tbody>
                <tfoot className="bg-white">
                    <tr className="font-semibold text-gray-900">
                        <th scope="row" className="px-6 py-3 text-base">
                            Total
                        </th>
                        {[
                            ["mercadopago", getTotalsByType("mercadopago")],
                            ["redelcom", getTotalsByType("redelcom")],
                            ["manual", getTotalsByType("manual")],
                            ["product-redelcom", getTotalsByType("product-redelcom")],
                            ["product-manual", getTotalsByType("product-manual")],
                            ["total", totals.total_no_iva],
                            ["total", totals.total - totals.total_no_iva],
                            ["total", totals.total],
                        ].map(([type, total], index) => (
                            <td
                                key={`tfoot-table-total-prices-list-item-${type}-${index}`}
                                className="px-6 py-3"
                            >
                                ${numberFormat(total, 0, "", ".")}
                            </td>
                        ))}
                    </tr>
                </tfoot>
            </table>
        </div>
    );
};

export default Table;
